import React from 'react'
import { Link } from '@inertiajs/react'
import styles from './DropdownMenuLink.module.scss'

interface DropdownMenuLinkProps {
  href: string
  method?: 'get' | 'post' | 'put' | 'patch' | 'delete'
  as?: string
  children: React.ReactNode
  className?: never
}

export const DropdownMenuLink: React.FC<DropdownMenuLinkProps> = ({
  href,
  method = 'get',
  as = 'a',
  children,
}) => (
  <Link href={href} method={method} as={as} className={styles.link}>
    {children}
  </Link>
)
